import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import {
  ClassNameMap,
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { withStyles, makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

const StyledDialog = withStyles(MuiDialog, {
  paper: {
    minWidth: 500,
  },
});

const StyledTitle = withStyles(DialogTitle, (theme) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: `22px ${theme.spacing(4)} ${theme.spacing(4)}`,
    fontSize: 28,
    lineHeight: "30px",
    letterSpacing: -0.5,
    fontWeight: 700,
  },
}));

const StyledContent = withStyles(DialogContent, (theme) => ({
  root: {
    padding: theme.spacing(4),
  },
}));

const StyledActions = withStyles(DialogActions, (theme) => ({
  root: {
    justifyContent: "center",
    paddingTop: 32 - +theme.spacing(4), // minus 4 spacing to account for StyledContent padding
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingBottom: 31,
  },
}));

const CloseIconButton = withStyles(IconButton, (theme) => ({
  root: {
    padding: theme.spacing(1),
    color: colors.grey,
    backgroundColor: "#E8EEF6",
  },
}));

const useStyles = makeStyles()((theme) => ({
  titleText: {
    marginRight: theme.spacing(10),
  },
}));

export interface DialogProps {
  className?: string;
  classes?: Partial<ClassNameMap<"paper">>;
  contentClassName?: string;
  open: boolean;
  onClose: () => void;
  title?: string;
  titleId?: string;
  content?: React.ReactNode;
  actions?: React.ReactNode;
}

const Dialog: React.FC<DialogProps> = ({
  className,
  classes,
  contentClassName,
  open,
  onClose,
  titleId,
  title,
  content,
  actions,
}) => {
  const { classes: myClasses } = useStyles();
  return (
    <StyledDialog
      className={className}
      classes={classes}
      open={open}
      onClose={onClose}
      aria-labelledby={titleId}
    >
      <StyledTitle id={titleId}>
        <span className={myClasses.titleText}>{title ?? ""}</span>
        <CloseIconButton aria-label="close" onClick={onClose} size="small">
          <CloseIcon fontSize="small" />
        </CloseIconButton>
      </StyledTitle>
      <StyledContent className={contentClassName}>{content}</StyledContent>
      <StyledActions>{actions}</StyledActions>
    </StyledDialog>
  );
};

export default Dialog;
